import { DEFAULT_CUSTOMER_ID } from 'stores/pet-profile-new/constants';

// converts numeric id to string, returns DEFAULT_CUSTOMER_ID in case of null
export const getCustomerKey = (customerId: null | number): string => {
  return customerId == null ? DEFAULT_CUSTOMER_ID : String(customerId);
};
